import { makeStyles } from "tss-react/mui";

import { Theme } from "@mui/material";

import { Props } from "./Tag";

const getColor = (props: Props, theme: Theme) => [
    props.generated ? theme.palette.emteria.tag.generated : theme.palette.emteria.tag.user,
    theme.palette.emteria.text.inverse,
    theme.palette.emteria.text.primary,
];

export const useStyles = makeStyles<Props, "icon">()((theme: Theme, props) => ({
    container: {
        borderRadius: 50,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        maxWidth: "100%",
        backgroundColor: getColor(props, theme)[0],
        padding: 2,
        cursor: props.onClick ? "pointer" : "default",
    },
    keyBox: {
        display: "flex",
        minWidth: 0,
        alignItems: "center",
        justifyContent: "center",
        padding: theme.spacing(0, 2),
        color: getColor(props, theme)[1],
    },
    valueBox: {
        display: "flex",
        minWidth: 0,
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: theme.palette.emteria.text.inverse,
        borderTopRightRadius: 50,
        borderBottomRightRadius: 50,
        padding: theme.spacing(0, 2),
        color: getColor(props, theme)[2],
    },
    label: {
        maxWidth: 240,
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
    },
    icon: {
        color: getColor(props, theme)[1],
        fontSize: 9,
    },
    button: {
        position: "absolute",
        right: theme.spacing(-1),
        top: theme.spacing(-1),
        width: 13,
        height: 13,
        padding: 0,
        borderRadius: 50,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",

        backgroundColor: getColor(props, theme)[0],
        border: "none",
        "&:hover": {
            backgroundColor: getColor(props, theme)[0],
            opacity: 1,
        },
    },
}));
